const orderSubDirectory = "/order";

export const createOrder = `${orderSubDirectory}/createOrderForSalesWebsite`;

export const getFollowUpOrderDetails = `${orderSubDirectory}/:orderId/getFollowUpOrderDetails`;

export const GET_DELIVERY_SLOTS = `${orderSubDirectory}/getDeliverySlots/v2`;

export const GET_FREE_EXPRESS_DELIVERY_PROMO = `${orderSubDirectory}/getFreeExpressDeliveryPromoBanner`;
